export default __webpack_public_path__ + "static/media/imgg4.6619d0c9.webp";